import { render, staticRenderFns } from "./PurchaseOrderExpense.vue?vue&type=template&id=6f9d1573&"
import script from "./PurchaseOrderExpense.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderExpense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports